import { DirectoryConfig } from './../../../models/directory-config.model';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { concatMap } from 'rxjs/operators';
import { CONSTANTS } from 'src/environments/constants';
import { DirectorySearchService } from './../../../services/directory-search/directory-search.service';
import { DirectorySharedDataService } from './../../../services/directory-shared-data.service';
import { DirectoryUtilsService } from 'src/app/directory/services/directory-utils/directory-utils.service';

@Component({
  selector: 'app-entities-links',
  templateUrl: './entities-links.component.html',
  styleUrls: ['./entities-links.component.scss']
})
export class EntitiesLinksComponent implements OnChanges {
  @Input() fieldValue: string;
  @Input() trueLink: boolean = false;
  public widgetConfig: DirectoryConfig;
  public hasMultipleLinks: boolean = false;

  public visibleEntities: Object[] = [];

  @Output() actuallyEmpty = new EventEmitter<boolean>();

  constructor(
    private directorySearch: DirectorySearchService,
    private directoryStore: DirectorySharedDataService,
    private utils: DirectoryUtilsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.fieldValue && changes['fieldValue']) {
      this.updateVisibleFields();
    }
  }

  private updateVisibleFields() {
    // console.debug(this.fieldValue);

    // // Actually don't need to change the existing code that much, just add the emit
    // this.directorySearch.getAllowedItems(null).subscribe(allowedIds => {
    //   console.debug("List of allowed entities IDs", allowedIds);
    //   console.debug("Compare to field's value", this.fieldValue);

    //   // Creating a list of ids
    //   let valuesAsArray: any[] = [];
    //   if (Array.isArray(this.fieldValue)) {
    //     this.hasMultipleLinks = true;
    //     this.fieldValue.forEach(entity => {
    //       valuesAsArray.push(this.utils.getElementId(entity));
    //     });
    //   } else {
    //     this.hasMultipleLinks = false;
    //     valuesAsArray.push(this.fieldValue);
    //   }

    //   // Finding allowed ids among that list
    //   let tempVisibleEntities = [];
    //   valuesAsArray.forEach(crtValue => {
    //     if (allowedIds.includes(crtValue)) {
    //       tempVisibleEntities.push(crtValue);
    //     }
    //   });

    //   this.visibleEntities = tempVisibleEntities;
    //   if (this.visibleEntities.length < 1) {
    //     this.actuallyEmpty.emit(true);
    //   } else {
    //     this.actuallyEmpty.emit(false);
    //   }
    // });


    this.directoryStore.getDirectoryConfig().pipe(
      concatMap((config: DirectoryConfig) => {
        this.widgetConfig = config;
        let idsArray: string[] = [];
        
        if (Array.isArray(this.fieldValue)) {
          this.hasMultipleLinks = true;
          this.fieldValue.forEach(element => {
            idsArray.push(this.utils.getElementId(element));
          });
        } else {
          this.hasMultipleLinks = false;
          idsArray.push(this.fieldValue);
        }

        return this.directorySearch.findEntitiesByIds(idsArray, [CONSTANTS.mainName]);
      }),
    ).subscribe((searchResponse) => {
      let visibleEntities = [];
      searchResponse.entities.forEach(crtEntity => {
        if (crtEntity[CONSTANTS.mainName]) {
          let entityLabel = {};
          entityLabel['id'] = crtEntity.entity_id;
          entityLabel['label'] = crtEntity[CONSTANTS.mainName];
          visibleEntities.push(entityLabel);
        }
      });
      this.visibleEntities = visibleEntities;
      // console.debug("Updated list of visible entities:");
      // console.debug(this.visibleEntities);
      if (this.visibleEntities.length < 1) {
        this.actuallyEmpty.emit(true);
      } else {
        this.actuallyEmpty.emit(false);
      }
    });
  }

}
